/**
 * Notification relative-time formatter — Flutter-verbatim port.
 *
 * Mirrors `scrips_core/lib/utils/date_time_utils.dart:257-283`
 * (`getNotificationDateFormat`). The breakpoints + capped "8 days ago"
 * ceiling + exact phrasing are copied 1:1 from the Dart helper so the
 * panel reads identically to Flutter PM. **Do not swap in
 * `date-fns/formatDistanceToNow` — its breakpoints + grammar differ**
 * (e.g. "about 1 hour ago" vs "1 hr ago"; "5 minutes" vs "5 minutes",
 * yes, but "less than a minute ago" vs "Just now"; no "8 days ago" cap).
 *
 * The Flutter helper has a `numericDates: true` default — React mirrors
 * the `true` branch ("1 week ago", "1 day ago", "1 hr ago", "1 minute
 * ago"). The `false` branch ("Last week", "Yesterday", etc.) is unused
 * in the notification surface (Flutter screen never passes `false`).
 */
export function formatNotificationDate(notificationDate: Date, now: Date = new Date()): string {
  const diffMs = now.getTime() - notificationDate.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffDays > 8) return '8 days ago';
  if (Math.floor(diffDays / 7) >= 1) return '1 week ago';
  if (diffDays >= 2) return `${diffDays} days ago`;
  if (diffDays >= 1) return '1 day ago';
  if (diffHours >= 2) return `${diffHours} hrs ago`;
  if (diffHours >= 1) return '1 hr ago';
  if (diffMinutes >= 2) return `${diffMinutes} minutes ago`;
  if (diffMinutes >= 1) return '1 minute ago';
  if (diffSeconds >= 10) return `${diffSeconds} seconds ago`;
  return 'Just now';
}
